"use client";

import type React from "react";
import { createContext, useContext, useState } from "react";

type CreateMenuContextType = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const CreateMenuContext = createContext<CreateMenuContextType | undefined>(
  undefined,
);

export const CreateMenuProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CreateMenuContext.Provider
      value={{
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        toggle: () => setIsOpen((v) => !v),
      }}
    >
      {children}
    </CreateMenuContext.Provider>
  );
};

export function useCreateMenu() {
  const ctx = useContext(CreateMenuContext);
  if (!ctx) {
    throw new Error("useCreateMenu must be used within CreateMenuProvider");
  }
  return ctx;
}
